import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './FormDatePicker.scss';
import FormField from './FormField';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import 'assets/css/override-react-datepicker.css';

export default class FormTimePicker extends Component {
    static propTypes = {
        label: PropTypes.string,
        error: PropTypes.string,
        onChange: PropTypes.func
    };

    render() {
        const {label, error, className, ...datepickerProps} = this.props;
        const inputClassName = classNames(styles.field, className, {
            [styles.highlightError]: Boolean(error)
        });
        return (
            <FormField label={label} error={error}>
                <DatePicker
                    className={inputClassName}
                    showTimeSelect
                    showTimeSelectOnly
                    dateFormat="h:mm a"
                    {...datepickerProps}
                    error={error}
                />
            </FormField>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/controls/form/FormTimePicker.js